<template>
  <div>
    <hr />

    <DataTable
      :data="medicos"
      :columns="[
        { label: 'Especialidad', field: 'especialidadNombre' },
        { label: 'Documento',   field: 'personaDocumento' },
      ]"
      idField="idMedico"
      mensajeVacio="No hay médicos registrados."
      :acciones="true"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      :mostrarBotonNuevo="false"
      @refresh="getData"
    >
      <!-- Barra de acciones extra: buscador + nuevo -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-2">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar por nombre..."
            style="width:260px; text-transform:uppercase"
            @keyup.enter="getData"
          />
          <button
            class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
            @click="getData"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span> Buscar
          </button>
        </div>
        <div class="col-auto">
          <button
            class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            data-bs-toggle="modal"
            data-bs-target="#ventanaModal"
            @click="abrirModalCrear"
            title="Nuevo registro"
          >
            <span class="material-icons" style="font-size:16px">add_box</span> Nuevo
          </button>
        </div>
      </template>

      <!-- Acciones por fila -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-warning me-1"
          @click="abrirModalEditar(row.idMedico)"
          title="Editar"
        >
          <span class="material-icons" style="font-size:14px">edit</span>
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="deleteMedico(row.idMedico)"
          title="Eliminar"
        >
          <span class="material-icons" style="font-size:14px">delete</span>
        </button>
      </template>
    </DataTable>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="ventanaModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">medical_services</span>
            <h5 class="modal-title text-white ms-2" id="ventanaModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="row g-3">

                <!-- Id Médico (solo editar) -->
                <div class="col-md-2" v-if="btnEditar">
                  <label class="form-label fw-bold">Id Médico</label>
                </div>
                <div class="col-md-10" v-if="btnEditar">
                  <input type="text" class="form-control bg-light" v-model="datoMedico.idMedico" disabled />
                </div>

                <!-- Especialidad -->
                <div class="col-md-2">
                  <label class="form-label fw-bold">Especialidad</label>
                </div>
                <div class="col-md-10">
                  <select class="form-select" v-model="datoMedico.idEspecialidad">
                    <option
                      v-for="e in especialidads"
                      :key="e.idEspecialidad"
                      :value="e.idEspecialidad"
                    >{{ e.nombre }}</option>
                  </select>
                </div>

                <!-- Documento -->
                <div class="col-md-2">
                  <label class="form-label fw-bold">Documento</label>
                </div>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoMedico.documento"
                    style="text-transform:uppercase"
                    required
                  />
                </div>

              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              type="button"
              class="btn btn-success px-4"
              @click.prevent="guardarMedico"
              title="Guardar"
            >
              <span class="material-symbols-outlined align-middle">save</span> Guardar
            </button>
            <button
              v-if="btnEditar"
              type="button"
              class="btn btn-success px-4"
              @click.prevent="guardarEditMedico"
              title="Actualizar"
            >
              <span class="material-symbols-outlined align-middle">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import { validarForm } from '@/modules/validacionesForms.js';
import api from '@/services/api';
import * as $ from 'jquery';
import swal from 'sweetalert';
window['$'] = $;
window['jQuery'] = $;

export default {
  components: { DataTable },

  props: {
    p_idPersona: { type: String, required: true },
  },

  data() {
    return {
      medicos:       [],
      datoMedico:    {},
      nombreBusqueda:'',
      titulo:        '',
      btnCrear:      false,
      btnEditar:     false,
      modalWindow:   true,
      especialidads: [],
    };
  },

  mounted() {
    this.getData();
    this.fetchEspecialidads();
  },

  methods: {
    //  Carga
    async getData() {
      const response = await api.get('/vwmedicos/idpersona/' + this.p_idPersona);
      this.medicos = response.data.reverse();
    },

    //  Validación
    validarForm() {
      return validarForm(
        this.datoMedico,
        ['idEspecialidad', 'documento'],
        ['Especialidad', 'Documento']
      );
    },

    //  CRUD
    async guardarMedico() {
      if (this.validarForm() === 1) {
        try {
          this.datoMedico.idPersona = this.p_idPersona;
          const idEmpresa     = window.sessionStorage.getItem('idEmpresa');
          const idSuscripcion = window.sessionStorage.getItem('idSuscripcion');
          await api.post(
            `/medicos?idEmpresa=${idEmpresa}&idSuscripcion=${idSuscripcion}`,
            this.datoMedico
          );
          $('#ventanaModal').modal('hide');
          swal('Correcto!', 'Médico creado exitosamente!', 'success');
          this.getData();
        } catch {
          swal('Error!', 'Inténtelo de nuevo!', 'error');
        }
      }
    },

    async guardarEditMedico() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/medicos', this.datoMedico);
          $('#ventanaModal').modal('hide');
          swal('Correcto!', 'Médico actualizado exitosamente!', 'success');
          this.getData();
        } catch (error) {
          swal('Error!', 'Inténtelo de nuevo!', 'error');
          if (error.response?.data?.errors) {
            Object.values(error.response.data.errors).forEach(e => swal(String(e)));
          }
        }
      }
    },

    async deleteMedico(idMedico) {
      try {
        await api.delete('/medicos/' + idMedico);
        this.getData();
      } catch {
        swal('Error!', 'No se pudo eliminar.', 'error');
      }
    },

    //  Modal
    abrirModalCrear() {
      this.datoMedico = {};
      this.titulo     = 'Crear Médico';
      this.btnCrear   = true;
      this.btnEditar  = false;
    },

    abrirModalEditar(idMedico) {
      this.modalWindow = true;
      if (idMedico != null) {
        api.get('/vwmedicos/' + idMedico).then(resp => {
          this.datoMedico = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo    = 'Editar Médico';
      this.btnCrear  = false;
      this.btnEditar = true;
    },

    //  Catálogos
    fetchEspecialidads() {
      api.get('/vwespecialidads')
        .then(r => { this.especialidads = r.data; })
        .catch(e => console.error('Error fetchEspecialidads:', e));
    },
  },
};
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>